import { useEffect } from "react";
import { usePlanning } from "../context/PlanningContext";
import { authService } from "../../../services/authService";
import { PlanningLLMService } from "../../../services/llm/PlanningLLMService";
export const usePlanningInitialize = () => {
    const { setReady, setdocumentId, setAdapter, setBackendBaseUrl } = usePlanning();
    useEffect(() => {
        const service = PlanningLLMService.instance();
        const applyInitPayload = (payload) => {
            console.log('[Planning] Received init payload', payload);
            if (payload.auth) {
                console.log('[Planning] Hydrating auth state');
                authService.hydrateAuthState(payload.auth);
            }
            const backendUrl = payload.backendBaseUrl ?? 'http://localhost:3000';
            service.setEnvironment({
                backendBaseUrl: backendUrl,
                adapter: payload.adapter,
                currentdocumentId: payload.documentId ?? null,
            });
            // Store the current deck ID on window for the DeckRegistry bridge to use
            // This is needed because the dialog context can't call PowerPoint.run() reliably
            if (payload.documentId) {
                window.__currentdocumentId = payload.documentId;
                console.log('[Planning] Stored current deck ID on window:', payload.documentId);
            }
            // Update React state
            setBackendBaseUrl(backendUrl);
            setAdapter(payload.adapter || null);
            setdocumentId(payload.documentId || null);
            setReady(true);
            console.log('[Planning] Environment configured', {
                backendBaseUrl: backendUrl,
                adapter: payload.adapter,
                documentId: payload.documentId ?? null,
            });
        };
        // Register dialogMessageHandler
        if (typeof window.dialogMessageHandler === 'undefined') {
            window.dialogMessageHandler = (message) => {
                try {
                    const data = JSON.parse(message);
                    console.log('[Planning] dialogMessageHandler received', data);
                    if (data.type === 'init') {
                        applyInitPayload(data);
                    }
                }
                catch (error) {
                    console.error('[Planning] Failed to parse message:', error);
                }
            };
        }
        // Office.js handler
        const OfficeGlobal = window.Office;
        if (OfficeGlobal?.context?.ui?.addHandlerAsync) {
            OfficeGlobal.context.ui.addHandlerAsync(OfficeGlobal.EventType.DialogParentMessageReceived, (arg) => {
                if (!arg.message)
                    return;
                try {
                    const data = JSON.parse(arg.message);
                    console.log('[Planning] Office handler received', data);
                    if (data.type === 'init') {
                        applyInitPayload(data);
                    }
                }
                catch (error) {
                    console.error('[Planning] Failed to parse Office message:', error);
                }
            });
        }
        // Window message handler
        const handleWindowMessage = (event) => {
            try {
                const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                console.log('[Planning] Window message received', data);
                if (data?.type === 'init') {
                    applyInitPayload(data);
                }
            }
            catch (error) {
                console.error('[Planning] Failed to parse window message:', error);
            }
        };
        window.addEventListener('message', handleWindowMessage);
        // Notify parent that page is ready
        // Delay slightly to ensure parent's event handler is set up
        setTimeout(() => {
            try {
                const OfficeRef = window.Office;
                OfficeRef?.context?.ui?.messageParent(JSON.stringify({ type: 'ready' }));
                console.log('[Planning] Notified parent - ready');
            }
            catch (error) {
                console.warn('[Planning] Failed to notify parent:', error);
            }
        }, 100);
        return () => {
            window.removeEventListener('message', handleWindowMessage);
        };
    }, [setReady, setdocumentId, setAdapter, setBackendBaseUrl]);
};
